<template>
    <div class="width50 padding-right-20 outlookOverview scrollBox highlights--results hideMobile">
        <h3 class="hl-module text-color--primary-contrast margin-top-15 margin-bottom-10 margin-left-20">
            {{ marketName }}
        </h3>
        <h4 class="h3 margin-bottom-2 margin-left-20">
            {{ market }}
        </h4>
        <div class="margin-bottom-15 margin-left-20">
            <p class="margin-bottom-2">
                {{ description }}
            </p>
        </div>
        <div class="margin-bottom-15 margin-left-20">
            <a
                :href="marketLink"
                class="linkArrowHover margin-top-20"
                :data-gtm="gtm"
                tabindex="-1">
                <svg
                    aria-hidden="true"
                    class="stat__svgIcon">
                    <use href="#iconArrowRightLongBold" />
                </svg>
                {{ trans('XMO_HIGHLIGHTS_OUTLOOK_EXPLORE') }}
            </a>
        </div>
    </div>
</template>

<script>
    import Translator from 'tools/trans';

    export default {
        props: {
            marketName: { type: String, required: true },
            market: { type: String, required: true },
            description: { type: String, required: true },
            marketLink: { type: String, required: true },
            gtm: { type: String, required: true },
        },
        methods: {
            trans: Translator.trans,
        },
    };
</script>
